import { App, ConfigProvider } from 'antd';
import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { GlobalStyles } from './style';
import ru_RU from 'antd/es/locale/ru_RU';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import duration from 'dayjs/plugin/duration';
import 'dayjs/locale/ru';
import { router } from './app.routes';
dayjs.locale('ru_ru');
dayjs.extend(utc);
dayjs.extend(duration);

const Root = () => {
    return <ConfigProvider
        locale={ru_RU}
        theme={{
            components: {
                Splitter: {
                    splitBarDraggableSize: 0,
                }
            }
        }}
    >
        <App>
            <GlobalStyles />
            <RouterProvider router={router} />
        </App>
    </ConfigProvider>;
};

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<Root />);
